import { createAsyncThunk } from "@reduxjs/toolkit";
import { createReducerThunk, initialState } from ".";
import { loginService } from "../api/services/authentication";

export const loginThunk: any = createAsyncThunk("authentication/loginThunk", loginService);
export const authenticationSlice = createReducerThunk("authentication", initialState, loginThunk);
export const authenticationReset = authenticationSlice.actions.reset;

export default authenticationSlice.reducer;
